import styled from 'styled-components';
import ContentLoader from 'react-content-loader';

export const PieChartLoaderWrapper = styled.div`
  margin-top: -2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 37rem;
  height: 32rem;
`;

export const StyledLoader = styled(ContentLoader)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const InnerCircle = styled.div`
  position: absolute;
  width: 21rem;
  height: 21rem;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.surface.default};
  z-index: 1;
`;

export const InnerCircleLoader = styled(ContentLoader)`
  width: 100%;
  height: 100%;
  border-radius: 50%;
`;

export const Text = styled.rect`
  width: 7rem;
  height: 2.4rem;

  x: 35%;
  y: 32%;

  rx: 0.5rem;
  ry: 0.5rem;
`;

export const Amount = styled.rect`
  width: 11rem;
  height: 2.8rem;

  x: 25%;
  y: 50%;

  rx: 0.5rem;
  ry: 0.5rem;
`;
